import { Component, input, viewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIcon } from '@ng-icons/core';
import { Button, Notification } from 'excellence-ui';

@Component({
  selector: 'app-locations-create-success-notification',
  imports: [Notification, Button, NgIcon, RouterLink, TranslocoPipe],
  templateUrl: './locations-create-success-notification.html',
})
export class LocationsCreateSuccessNotification {
  notification = viewChild(Notification);

  uuid = input.required<string>();
  duration = input.required<number>();

  organizationId = input.required<string>();
  locationId = input.required<string>();
  locationName = input.required<string>();
}
